import React from "react";
import Page from "../components/Page";
import Grid from "@mui/material/Grid";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import Button from "../elements/Button";
import { useNavigate } from "react-router-dom";
import { patreonUrl, tgLink } from "../constants";

const Landing = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate("/home");
  };

  return (
    <Page>
      <Grid item xs={12}>
        <div className="bg-primary flex flex-col relative">
          <div className="relative overflow-none bg-[linear-gradient(90deg,_theme('colors.primary'),_theme('colors.primaryLight')_50%,_theme('colors.primary'))] h-[340px] md:h-[440px] ">
            <div className="absolute left-0 top-0 h-full w-full flex flex-col items-center justify-center">
              <div className="flex py-8 md:py-12 flex-col items-center justify-between h-full">
                <img
                  src="/chl.png"
                  className="h-32 relative -top-10 hidden md:block"
                  alt=""
                />
                <img
                  src="/cup.png"
                  alt=""
                  className="absolute h-72 bottom-[53px]"
                />

                <div className="w-full absolute bottom-0 left-0 right-0 flex justify-center items-center">
                  <div className="rounded-t-xl w-60 h-24 bg-primary flex justify-center items-center">
                    <Button onClick={goToHome}>
                      <ExitToAppIcon />
                      &nbsp;Перейти до гри
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <p className="text-black bg-cyan px-2 pt-4">
              <strong>ФУТБАТЛ</strong> - це турнір футбольних прогнозів{" "}
              <u>без букмекерів і грошових ставок</u>, який робить перегляд
              футболу ще більш цікавим.
            </p>
            <div className="px-2 py-4 from-cyan to-yellow bg-gradient-to-b flex flex-col md:flex-row md:gap-4">
              <div className="md:w-[50%] w-full">
                <h3 className="flex items-center h-8 rounded-[20px_194px_0px_0px/21px_119px_1px_0px] text-white m-0 uppercase font-bold mb-4 pl-[1.25rem] bg-gradient-to-r from-primary to-primaryLight">
                  Як грати?
                </h3>
                <p className="text-black mb-4">
                  ✅ Прогнозуйте рахунки футбольних матчів Ліги Чемпіонів
                </p>

                <p className="text-black mb-4">
                  ✅ Забивайте голи у ворота суперників кожного туру
                </p>

                <p className="text-black mb-4">
                  ✅ Набирайте очки та перемагайте
                </p>
                <h3 className="flex items-center h-8 rounded-[20px_194px_0px_0px/21px_119px_1px_0px] text-white m-0 uppercase font-bold mb-4 pl-[1.25rem] bg-gradient-to-r from-primary to-primaryLight">
                  Регламент турніру
                </h3>
                <p className="text-black mb-4">
                  ✅ Турнір створено для патронів каналу{" "}
                  <a target="_blank" rel="noreferrer" href={patreonUrl}>
                    Фентезі Футбол
                  </a>
                  . Нові учасники мають 3 тижні пробного доступу, після чого для
                  продовження гри потрібно{" "}
                  <a target="_blank" rel="noreferrer" href={patreonUrl}>
                    стати патроном
                  </a>
                  .
                </p>
                <p className="text-black mb-4">
                  ✅ Турнір триватиме 8 турів протягом етапу Ліги (з 16 вересня
                  до 28 січня).
                </p>
                <p className="text-black mb-4">
                  ✅ Усі учасники, які зареєструвалися у грі, надсилають свої
                  прогнози на матчі Ліги Чемпіонів. Головна задача - правильно
                  спрогнозувати рахунки або результати матчів.
                </p>

                <p className="text-black mb-4">
                  ✅ Змінювати прогноз на конкретний футбольний матч можна
                  безліч разів до завершення дедлайну - запланованого часу
                  початку футбольного матчу.{" "}
                </p>

                <p className="text-black mb-4">
                  ✅ Усі учасники, які відправили хоча б один прогноз до
                  завершення дедлайну туру, беруть участь{" "}
                  <strong>
                    у жеребкуванні, яке визначає суперника на тур{" "}
                  </strong>{" "}
                  для кожного учасника гри.
                </p>
                <p className="text-black mb-4">
                  ✅ Дедлайном туру <strong>є час старту першого матчу</strong>{" "}
                  туру.
                </p>
                <p className="text-black mb-4">
                  ✅ Якщо учасників буде непарна кількість, у гру вступить
                  віртуальний гравець <strong>ФУТБАТЛИК</strong>. Він бере
                  участь у жеребкуванні, щоб скласти пару одному з гравців, і
                  завжди надсилає прогнози до початку туру, дотримуючись
                  принципів чесної гри.
                </p>
              </div>

              <div className="md:w-[50%] w-full text-primary">
                <h3 className="flex items-center h-8 rounded-[20px_194px_0px_0px/21px_119px_1px_0px] text-white m-0 uppercase font-bold mb-4 pl-[1.25rem] bg-gradient-to-r from-primary to-primaryLight">
                  Календар
                </h3>
                <div className="mb-4 p-2 bg-white flex justify-between rounded-xl font-bold">
                  <div>ТУР 1</div>
                  <div>16 вересня</div>
                </div>
                <div className="mb-4 p-2 bg-white flex justify-between rounded-xl font-bold">
                  <div>ТУР 2</div>
                  <div>30 вересня</div>
                </div>
                <div className="mb-4 p-2 bg-white flex justify-between rounded-xl font-bold">
                  <div>ТУР 3</div>
                  <div>21 жовтня</div>
                </div>
                <div className="mb-4 p-2 bg-white flex justify-between rounded-xl font-bold">
                  <div>ТУР 4</div>
                  <div>4 листопада</div>
                </div>
                <div className="mb-4 p-2 bg-white flex justify-between rounded-xl font-bold">
                  <div>ТУР 5</div>
                  <div>25 листопада</div>
                </div>
                <div className="mb-4 p-2 bg-white flex justify-between rounded-xl font-bold">
                  <div>ТУР 6</div>
                  <div>9 грудня</div>
                </div>
                <div className="mb-4 p-2 bg-white flex justify-between rounded-xl font-bold">
                  <div>ТУР 7</div>
                  <div>20 січня</div>
                </div>
                <div className="mb-4 p-2 bg-white flex justify-between rounded-xl font-bold">
                  <div>ТУР 8</div>
                  <div>28 січня</div>
                </div>
                <h3 className="flex items-center h-8 rounded-[20px_194px_0px_0px/21px_119px_1px_0px] text-white m-0 uppercase font-bold mb-4 pl-[1.25rem] bg-gradient-to-r from-primary to-primaryLight">
                  Подарунок переможцю
                </h3>
                <p className="text-black mb-4">
                  ✅ Переможець турніру отримає подарунок - річну підписку на
                  популярну спортивну OTT платформу.
                </p>
                <h3 className="flex items-center h-8 rounded-[20px_194px_0px_0px/21px_119px_1px_0px] text-white m-0 uppercase font-bold mb-4 pl-[1.25rem] bg-gradient-to-r from-primary to-primaryLight">
                  Комунікація
                </h3>
                <p className="text-black">
                  ✅ Підпишіться на телеграм канал{" "}
                  <a target="_blank" rel="noreferrer" href={tgLink}>
                    ФУТБАТЛ
                  </a>
                  . Там ви зможете задати ваші запитання та отримувати
                  оповіщення про початок турів.
                </p>
              </div>
            </div>

            <div className="px-2 py-4 bg-lightgrey flex flex-col md:flex-row md:gap-4">
              <div className="md:w-[50%]">
                <h3 className="flex items-center h-8 rounded-[20px_194px_0px_0px/21px_119px_1px_0px] text-white m-0 uppercase font-bold mb-4 pl-[1.25rem] bg-gradient-to-r from-primary to-primaryLight">
                  Розрахунок батлу
                </h3>
                <p className="text-black mb-4">
                  ✅ Батл - це матч між двома учасниками гри (head-to-head), які
                  прогнозують однаковий набір футбольних матчів.
                </p>
                <p className="text-black mb-4">
                  ✅ Розрахунок результату батлу здійснюється шляхом
                  послідовного порівняння прогнозів двох учасників.
                </p>
                <p className="text-black mb-4">
                  ✅ Взяття воріт (гол) зараховується за наступними правилами:
                  <ul className="mt-2">
                    <li>
                      ⚽️ Точно спрогнозовано <strong>рахунок матчу</strong>{" "}
                    </li>{" "}
                    <li>
                      ⚽️ Правильно спрогнозовано{" "}
                      <strong>результат матчу</strong> (перемога, нічия,
                      поразка) <strong>на відміну від суперника</strong>
                      <br />
                      <br />
                      <i className="bg-gold/90">
                        Наприклад, якщо <strong>Учасник 1</strong> спрогнозував
                        рахунок <strong>2:0</strong>, а{" "}
                        <strong>Учасник 2</strong> спрогнозував рахунок{" "}
                        <strong>1:1</strong>, то після завершення матчу з
                        рахунком <strong>3:1</strong>,{" "}
                        <strong>Учасник 1</strong> заб'є гол у батлі.
                      </i>
                      <br />
                      <br />
                    </li>
                    <li>
                      ⚽️ Правильно спрогнозовано{" "}
                      <strong>різницю м'ячів у рахунку </strong>{" "}
                      <strong>на відміну від суперника </strong>
                      <br />
                      <br />
                      <i className="bg-gold/90">
                        Наприклад, якщо <strong> Учасник 1</strong> спрогнозував
                        рахунок <strong>2:0 (різниця +2)</strong>, а{" "}
                        <strong>Учасник 2</strong> спрогнозував рахунок{" "}
                        <strong>3:0 (різниця +3)</strong>, то після завершення
                        матчу з рахунком <strong>3:1 (різниця +2)</strong>,{" "}
                        <strong>Учасник 1</strong> заб'є гол у батлі.
                      </i>
                    </li>
                  </ul>
                </p>
                <p className="text-black mb-4">
                  ✅ За перемогу в батлі учасник отримує <strong>3 очки</strong>
                  , за нічию <strong>1 очко</strong>.
                </p>
                <p className="text-black mb-4">
                  ✅ У разі рівності очок у турнірній таблиці, вище буде той
                  учасник, який матиме перевагу: за різницею забитих та
                  пропущених м'ячів, кількістю забитих м'ячів.{" "}
                </p>
              </div>
              <div className="md:w-[50%]">
                <h3 className="flex items-center h-8 rounded-[20px_194px_0px_0px/21px_119px_1px_0px] text-white m-0 uppercase font-bold mb-4 pl-[1.25rem] bg-gradient-to-r from-primary to-primaryLight">
                  Приклад батлу
                </h3>
                <img
                  className="w-full rounded-xl"
                  alt=""
                  src="/battle-example.png"
                ></img>
                <div className="flex items-center justify-center mt-4">
                  <Button onClick={goToHome}>
                    <ExitToAppIcon />
                    &nbsp;Перейти до гри
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Grid>
    </Page>
  );
};

export default Landing;
